namespace TabAurous.Administration {
    export interface IntegrationRow {
        Type?: Common.IntegrationType;
        IntegrationType?: number;
        Username?: string;
        Password?: string;
        Url?: string;
        AccessKey?: string;
        SecretKey?: string;
        RoleArn?: string;
        RefreshToken?: string;
    }

    export namespace IntegrationRow {
        export const idProperty = 'Username';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Administration.Integration';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Type = "Type",
            IntegrationType = "IntegrationType",
            Username = "Username",
            Password = "Password",
            Url = "Url",
            AccessKey = "AccessKey",
            SecretKey = "SecretKey",
            RoleArn = "RoleArn",
            RefreshToken = "RefreshToken"
        }
    }
}
